// Statuts de PAIEMENT — domaine DISTINCT des statuts de commande (orderStatus.js).
// Codes EN, DÉRIVÉS (jamais stockés) : calculés depuis total payé vs total final.
// ⚠️ 'pending' ici n'a AUCUN rapport avec un statut de commande.

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PARTIAL: 'partial',
  PAID: 'paid',
};

// Métadonnées d'affichage : couleur MUI + clé i18n (libellés dans les traductions, clés déjà existantes).
export const PAYMENT_STATUS_META = {
  [PAYMENT_STATUS.PENDING]: { colorKey: 'warning', i18nKey: 'orders.paymentStatusPending' },
  [PAYMENT_STATUS.PARTIAL]: { colorKey: 'info',    i18nKey: 'orders.paymentStatusPartial' },
  [PAYMENT_STATUS.PAID]:    { colorKey: 'success', i18nKey: 'orders.paymentStatusPaid' },
};

// Règle de dérivation — reprise À L'IDENTIQUE des 2 copies (ordre des branches préservé) :
//   total final == 0            -> pending
//   total payé  == 0            -> pending
//   reste (final - payé) > 0    -> partial
//   sinon                       -> paid
export const derivePaymentStatus = (totalFinal, totalPaid) => {
  const remaining = totalFinal - totalPaid;
  if (totalFinal === 0) return PAYMENT_STATUS.PENDING;
  if (totalPaid === 0) return PAYMENT_STATUS.PENDING;
  if (remaining > 0) return PAYMENT_STATUS.PARTIAL;
  return PAYMENT_STATUS.PAID;
};
